import React from 'react';
import { Check } from 'lucide-react';

export default function TermsCheckbox({ checked, onChange }) {
  return (
    <label
      data-testid="terms-checkbox-label"
      className={`flex items-start gap-3 p-3.5 rounded-xl border cursor-pointer transition-colors ${checked ? 'border-brand/50 bg-brand/[0.06]' : 'border-amber-400/30 bg-amber-400/[0.04]'}`}
    >
      <input
        type="checkbox"
        data-testid="terms-checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="sr-only peer"
      />
      <span className={`mt-0.5 h-5 w-5 shrink-0 rounded-md border flex items-center justify-center peer-focus-visible:ring-2 peer-focus-visible:ring-brand ${checked ? 'bg-brand border-brand text-black' : 'border-white/30'}`}>
        {checked && <Check className="h-3.5 w-3.5" strokeWidth={3} />}
      </span>
      <span className="text-xs text-white/70 leading-relaxed">
        I agree to the{' '}
        <a href="/terms" target="_blank" rel="noreferrer" data-testid="terms-link" className="text-brand underline underline-offset-2" onClick={(e) => e.stopPropagation()}>
          Terms of Service
        </a>
        . All sales are final: this is a digital product, delivered instantly, and is <span className="text-white font-semibold">non-refundable</span>. It's for my personal use only and must not be shared or resold.
      </span>
    </label>
  );
}
